import { useEffect, useState } from "react";
import { ReviewCard } from "@/components/ReviewsBlock";
import api from "@/lib/api";

export default function BookReview() {
  const [r, setR] = useState(undefined);
  useEffect(() => { api.get("/reviews/latest").then((res) => setR(res.data)).catch(() => setR(null)); }, []);
  if (!r) return null;
  return <div data-testid="book-review"><ReviewCard r={r} /></div>;
}
